//@flow
import * as React from 'react';

export default class CardDefaulFull extends React.Component<{}> {
  render() {
    return (
      <div className={'card cardDefault cardFull d-flex flex-column'}>
        {this.props.children}
      </div>
    );
  }
}
